import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Porto" />

        <footer>
          This project was coded by{" "}
          <a
            href="https://paulinaprassolbraz.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Paulina Prassol Braz
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/PaulinaBraz/weather-react"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourced on GitHub
          </a>{" "}
          and{" "}
          <a
            href="https://weather-react-app-paulina-braz.netlify.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            hosted on Netlify
          </a>
        </footer>
      </div>
    </div>
  );
}
